import { ComposableCommerceEvents } from 'sdk/composable-commerce/types/events/ComposableCommerceEvents';
import { SDK, ServerOptions } from '@commercetools/frontend-sdk';
import { TStoreInventory } from 'shared/types/cart';
import { ProductSKUsPayload } from 'sdk/composable-commerce/types/payloads/StockPayloads';
import { GetProductStockAction } from 'sdk/composable-commerce/types/actions/StockActions';

export type StockActions = {
  getProductInventory: GetProductStockAction;
};

export const getStockActions = (sdk: SDK<ComposableCommerceEvents>): StockActions => {
  return {
    getProductInventory: async (payload: ProductSKUsPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await sdk.callAction<TStoreInventory[]>({
        actionName: 'stock/getProductStock',
        payload,
        serverOptions: options.serverOptions,
      });
      return response;
    },
  };
};
